/**
 * @file markdown 容器
 * @author FengGuang(fengguang01@baidu.com)
 */

import React, { useCallback, useRef } from 'react';
import ReactMarkdown from 'react-markdown/with-html';
import { ReactMarkdownProps } from 'react-markdown';
import classNames from 'classnames';
import { Tooltip, message } from 'antd';
import { CopyOutlined } from '@ant-design/icons';
import copy from 'copy-text-to-clipboard';

import CodeBlock from './CodeBlock';

interface IMarkdownContainerProps extends ReactMarkdownProps {
    className?: string;
    source?: string;
    onCodeCopyClick?: () => void;
    showCopyIcon?: boolean;
}


// 覆盖默认的渲染结果，可覆盖选项参考源码
// https://github.com/rexxars/react-markdown/blob/master/src/renderers.js
const renderersOption = {
    code: CodeBlock
};

const MarkdownContainer: React.FC<IMarkdownContainerProps> = props => {
    const { source, className, showCopyIcon = false, ...rest } = props;
    const contentRef = useRef<HTMLDivElement>(null);

    const handleCopy = useCallback(() => {
        const copyValue = contentRef.current?.innerText || source || '';
        if (!copyValue) {
            return;
        }
        copy(copyValue);
        message.success('复制成功');
    }, [source]);


    return (
        <div className="markdown-container">
            {showCopyIcon && (
                <Tooltip title={'复制全部内容'}>
                    <CopyOutlined className="markdown-container-copy" onClick={handleCopy} />
                </Tooltip>
            )}
            <div ref={contentRef}>
                {/* @ts-ignore */}
                <ReactMarkdown
                    source={source}
                    escapeHtml={false}
                    renderers={renderersOption}
                    {...rest}
                    className={classNames('markdown-body', className)}
                />
            </div>
        </div>
    );
};

export default React.memo(MarkdownContainer);
